
export default {
  state: {
    navs: [],
    currentNav: {},
    formFields: {},
    innerStart: new Date(Date.now() - 2*24*60*60*1000),
    innerEnd: new Date()
  },

  mutations: {
    updateNavs(state, navs) {
      state.navs = navs
    },
    updateCurrentNav(state, currentNav) {
      state.currentNav = currentNav
    },
    updateFormFields(state, fields) {
      state.formFields = fields
    },
    updateInnerStart(state, newInnerStart) {
      state.innerStart = newInnerStart
    },
    updateInnerEnd(state, newInnerEnd) {
      state.innerEnd = newInnerEnd
    },
    resetInnerDates(state, reset) {
      state.innerStart = reset.newInnerStart
      state.innerEnd = reset.newInnerEnd
    }
  },

  actions: {
    async getNavs({ commit }) {
      try {
        const response = await this._vm.$http.get('navs')
        commit('updateNavs', response.data)
      } catch (error) {
        console.log(error)
      }
    },
    async getFormFields({ commit }, formtype) {
      try {
        const response = await this._vm.$http.get(`forms?form=${formtype}`)
        commit('updateFormFields', response.data)
      } catch (error) {
        console.log(error)
      }
    },
    updateCurrentNav({ commit }, currentNav) {
      commit('updateCurrentNav', currentNav)
    },
    // Datetimepicker
    updateInnerStart({ commit }, newInnerStart) {
      commit('updateInnerStart', newInnerStart)
    },
    updateInnerEnd({ commit }, newInnerEnd) {
      commit('updateInnerEnd', newInnerEnd)
    },
    resetInnerDates({ commit }) {
      const start = new Date(Date.now() - 2*24*60*60*1000)
      const end = new Date()
      commit('resetInnerDates', {'newInnerStart': start, 'newInnerEnd': end})
    }
  },

  getters: {
    navs(state) {
      return state.navs
    },
    currentNav(state) {
      return state.currentNav
    },
    formFields(state) {
      return state.formFields
    },
    innerStart(state) { // corrección de formato al iniciar
      if(typeof state.innerStart === 'string') {
        return new Date(Date.parse(state.innerStart))
      } else {
        return state.innerStart
      }
    },
    innerEnd(state) { // corrección de formato al iniciar
      if(typeof state.innerEnd === 'string') {
        return new Date(Date.parse(state.innerEnd))
      } else {
        return state.innerEnd
      }
    }
  }
}
